import store from "@/store";

export const mixinRemote = {
  computed: {
    solutionComplete: {
      get () {
        return store.getters.solutionComplete
      },
      set (value) {
        store.commit('setSolutionComplete', value)
      }
    },
    isApplResult () {
      return store.getters.isApplResult
    },
    solMappingYn () {
      return store.getters.solMappingYn
    },
    obdCheckYn () {
      return store.getters.obdCheckYn
    },
    anifitProUrl () {
      return store.getters.anifitProUrl
    },
    solutions () {
      return store.getters.solutions
    },
    mindWeatherUnit () {
      return this.solutions?.find(s => s.unitUseNo === 159)
    },
    mindNoteUnit () {
      return this.solutions?.find(s => s.unitUseNo === 152)
    },
    currentPlanIndex () {
      return store.getters.currentPlanIndex
    },
    useOrdDtl () {
      return store.getters.useOrdDtl
    },
    travelYn () {
      return this.useOrdDtl.travelYn
    },
    travelStopYn () {
      return this.useOrdDtl.travelStopYn
    },
    useOrdDtlIsNull () {
      return this.useOrdDtl.nullData
    },
    usePeriodDays () {
      return this.useOrdDtl.usePeriodDays
    },
    usePeriodStartDt () {
      return this.useOrdDtl.usePeriodStartDt
    },
    usePeriodStartDtSt () {
      return this.useOrdDtl.usePeriodStartDtSt
    },
    usePeriodEndDt () {
      return this.useOrdDtl.usePeriodEndDt
    },
    usePeriodEndDtSt () {
      return this.useOrdDtl.usePeriodEndDtSt
    },
    nickname () {
      return store.getters.nickname
    },
    avatarImages () {
      return store.getters.avatarImages
    },
    mindWeatherText () {
      return store.getters.mindWeatherText
    },
    guideNo () {
      return store.getters.guideNo
    },
    guides () {
      return store.getters.guides
    },
    guideInfo () {
      // 내부 오류로인해 API 통신조차 못하는 경우 추가
      return this.guideNo ? this.guides[this.guideNo] : this.guides[0]
    },
    denyCode () {
      return store.getters.denyCode
    },
    globalErrorStatus() {
      return store.getters.globalErrorStatus
    },
    isChat () {
      return store.getters.isChat
    },
    isFirst () {
      return store.getters.isFirst
    },
    isRealTalkNew () {
      return store.getters.isRealTalkNew
    },
  },
  methods: {
    unitDetail (unitUseNo, freeYn, key, currentPlanIndex, cmpltYn, lock) {

      if (unitUseNo < 1) {
        this.$alert('여행지원서를 먼저 완료하셔야<br/>서비스 이용이 가능합니다.')
      } else if (lock) {
        if(this.travelStopYn == 'Y'){
          const useStopStartDtSt = this.useOrdDtl.useStopStartDtSt;
          const useStopEndDtSt = this.useOrdDtl.useStopEndDtSt;
          this.$alert(`티켓 이용이 중지되었어요.<br/>(중지기간 ${useStopStartDtSt} ~ ${useStopEndDtSt})`)
        }else if (store.getters.clientCd === 'samsungfire') {
          this.$alert('집중관리(상담)티켓을 사용하고<br/>더 많은 미션을 경험해보세요!')
        } else if (store.getters.clientCd === 'b2c') {  // 일반회원
          this.$alert('티켓을 구매하고<br/>더 많은 미션을 경험해 보세요!')
        }
        else { // 기업회원
          this.$alert(
              this.hasActiveTrial
                  ? this.trialResumeAlertMessage
                  : '티켓을 사용하여<br/>더 많은 미션을 경험해 보세요!'
          )
        }
      } else if (key > currentPlanIndex) {
        this.$alert('미션을 순서대로 진행해주세요:)')
      } else {
        this.$router.push({name: '솔루션', query: {'unitUseNo': unitUseNo, 'freeYn': freeYn, 'cmpltYn':cmpltYn}})
      }
    }
  }
}
